import HttpProvider from './HttpProvider';

export default {
    HttpProvider
};